import service from '@/services'
import QueryString from 'qs'

export default {
  namespaced: true,
  state: {
    datas: [],
  },
  getters: {
    getData: state => id => state.datas.find(item => item.id == id),
  },
  mutations: {
    SET_DATA(state, data) {
      state.datas = data
    },
  },
  actions: {
    // send data penerimaan barang
    async save({}, payload) {
      try {
        const config = {
          url: '/input/penerimaan',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async saveBarang({}, payload) {
      try {
        const config = {
          url: '/input/penerimaan-barang',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async getDataById({}, id) {
      try {
        const config = {
          url: `/penerimaan/${id}`,
          method: 'get',
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)
        const body = response.data
        // Support both wrapped { data: {...} } and flat model payloads
        const result =
          body && body.data != null && typeof body.data === 'object' && !Array.isArray(body.data)
            ? body.data
            : body

        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async getDataBarang({ commit }, params = {}) {
      try {
        const config = {
          url: '/penerimaan-barang',
          method: 'get',
          params,
          paramsSerializer: params => QueryString.stringify(params),
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)
        const result = response.data && response.data.data ? response.data.data : []

        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async getData({ commit }, params = {}) {
      try {
        const config = {
          url: '/penerimaan',
          method: 'get',
          params,
          paramsSerializer: params => QueryString.stringify(params),
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)
        const result = response.data && response.data.data ? response.data.data : []
        const total =
          response.data && response.data.total != null
            ? response.data.total
            : result.length
        commit('SET_DATA', result)

        return Promise.resolve(Object.assign(result, { total }))
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async getNewNoInvoice({ commit }, params = {}) {
      try {
        const config = {
          url: '/penerimaan-invoice',
          method: 'get',
          params,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}
